import { I00DEBGAZ_State } from '@batical/types/src'

const I00DEBGAZ: I00DEBGAZ_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  gaz_uuid: 'FF913EF4-D290-423A-AFD0-A626F918931D',
  in_pci: 10.0,
  in_pressionGaz: 0.0,
  in_puissanceNominale: 0.0,
  in_temperatureGaz: 0.0,
  in_pressionAtmospherique: 1013.0,
  res_debitNormaux: 0.0,
  res_debitGazReel: 0.0,
  res_debitTopGaz36: 0.0,
  mode: 'none',
  calcul_code: 'I00DEBGAZ'
}

export default I00DEBGAZ
